import React from 'react';
import Button from '../../../components/Button';
import * as S from './ErrorInfo.style';
import { useNavigate } from 'react-router-dom';
import * as PATHS from '../../../constants/service/common/urlConstants';

interface IErrorInfoProps {
  code: number;
  message: string;
  content: string;
}

const ErrorInfo = (props: IErrorInfoProps): JSX.Element => {
  const { code = 404, message, content } = props;
  const navigate = useNavigate();

  const handleClickErrorButton = () => {
    if (code === 404) {
      navigate(PATHS.HOME_URL_PATH);
    } else {
      navigate(-1);
    }
  };

  return (
    <S.Container>
      <S.Wrapper>
        <S.ErrorMessageWrap>
          <S.Status>{code} Error</S.Status>
          <S.Message>{message}</S.Message>
        </S.ErrorMessageWrap>
        <S.ContentWrap>
          <p>{content}</p>
        </S.ContentWrap>
        <S.ButtonWrapper errorCode={code}>
          <Button
            color="primary"
            text={code === 404 ? '홈으로 이동' : '이전 페이지로 이동'}
            onClick={handleClickErrorButton}
          />
        </S.ButtonWrapper>
      </S.Wrapper>
    </S.Container>
  );
};

export default ErrorInfo;
